import React from 'react';
import { motion } from 'framer-motion';
import { QuizForm } from './QuizForm';
export function FinalCTA() {
  return <section id="join" className="py-32 px-6 md:px-12 bg-marigold/10" data-id="element-45">
      <div className="max-w-3xl mx-auto text-center" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-47">
          <h2 className="text-4xl md:text-5xl text-navy mb-6 font-serif tracking-wide" data-id="element-48">
            Join the familiar spaces community
          </h2>
          <p className="text-lg text-navy/70 font-light leading-relaxed" data-id="element-49">
            Familiar Spaces is for people building a life around family,
            friends, care, and city living. Come with a partner, a friend, a
            parent, or the person you always wished lived closer.
          </p>
        </motion.div>

        <QuizForm data-id="element-50" />
      </div>
    </section>;
}